<template>
	<v-app>
		<nav-drawer />
		<v-main>
			<dialog-disabled />
			<menu-top />
			<div class="gum-container">
				<div class="title text-center primary--text py-8">
					Мастер-классы по хоккею совместно с Федерацией Хоккея России по национальной программе подготовки хоккеистов «Красная Машина»
				</div>

				<v-img :src="Image000" />

				<!--  -->

				<v-row class="section-info">
					<v-col class="d-flex align-center" cols="12" sm="6" :style="style()">
						<div class="pa-12 white--text d-flex align-center flex-column">
							<p class="subheader" style="line-height: 100%">
								ГУМ-Каток приглашает <br />
								на бесплатные мастер-классы <br />
								по хоккею
							</p>
							<p>
								Школа «Красная Машина Юниор» совместно с общественно-государственным движением детей и молодёжи «Движение первых» 
								приглашает на бесплатные мастер-классы по хоккею на ГУМ-Катке.
							</p>
							<p>
								«Красная Машина» – национальная программа подготовки хоккеистов, созданная на основе современных инновационных 
								методик, которые доказали свою эффективность и помогают детям развивать навыки игрока высокого уровня.
							</p>
							<p>
								«Красная Машина Юниор» - инновационная хоккейная школа, ставшая одной из сильнейших школ московского региона, доказав, 
								что современный подход, внимание к каждому ребёнку и любовь к делу приносят результат. Индивидуальные планы, методика 
								мирового уровня, тренировочный процесс по Национальной программе подготовки хоккеистов «Красная машина», насыщенный 
								спортивный режим и качественное образование – всё это делает нашу школу по-настоящему уникальной. 
							</p>
							<p>
								Юные любители хоккея смогут выйти с клюшкой на лёд в самом сердце столицы, получить новые впечатления и провести время 
								с пользой. Для детей с разным уровнем подготовки предусмотрены две категории мастер-классов.
							</p>
							<p>
								Занятия проводят опытные действующие тренеры школы «Красная Машина Юниор», аккредитованные Федерацией хоккея России.
							</p>
						</div>
					</v-col>
					<v-col cols="12" sm="6" class="px-0 pb-0">
						<v-img :src="Image001" height="100%" />
					</v-col>
				</v-row>

				<v-row class="section-faq">
					<v-col cols="12" sm="6" class="pa-0">
						<v-img :src="Image002" height="100%" />
					</v-col>
					<v-col cols="12" sm="6" class="d-flex justify-center flex-column">
						<div class="primary--text pa-3">
							<div class="q"><strong>Когда?</strong></div>
							<div class="a">
								Декабрь: 6, 13, 20 <br />
								Январь: 10, 17, 24, 31 <br />
								Февраль: 7, 14, 21 <br />
							</div>

							<div class="q"><strong>Первая группа. «Хоккей для всех»</strong></div>
							<div class="a">
								<p>09:00 – 10:00. Дети 7-12 лет без опыта игры в хоккей и базовой подготовки.</p>
								<p>
									Что будет на мастер классе? <br />
									Обучение базовым навыкам владения коньками и клюшкой.
								</p>
							</div>

							<div class="q"><strong>Вторая группа. «Воспитанники хоккейных школ»</strong></div>
							<div class="a">
								<p>10:30 – 11:30. Дети 7-12 лет, занимающиеся в хоккейных школах. Начинающие спортсмены, уже имеющие минимальный опыт в хоккее.</p>
								<p>
									Что будет на мастер классе? <br />
									Упражнения, направленные на развитие основных технических качеств хоккеиста с учетом имеющегося уровня 
									подготовки участника (катание, бросок, передача и приём шайбы, элементы обводки соперника). 
									Дети будут разделены на мини-группы. За каждой группой закреплен свой тренер. 
								</p>
								<p>
									Максимальное количество участников в каждой группе - 24 человека. <br />
								</p>
							</div>
							<div class="q"><strong>Обращаем ваше внимание:</strong></div>
							<div class="a">
								<ul>
									<li>
										Количество мест ограничено – 24 чел
									</li>
									<li>
										Вы можете принять участие в мастер-классах только один раз за сезон.
									</li>
									<li>
										Если вы хотите прийти на мастер-класс с вашим ребенком, пожалуйста, получите бесплатный билет сопровождения 
										в кассе ГУМ-Катка перед началом сеанса. Билет сопровождения не дает возможности выхода на лед. Для получения 
										бесплатного билета сопровождения на кассе нужно показать распечатанный билет на мастер-класс.
									</li>
									<li>
										Пожалуйста, оставляйте актуальные e-mail адреса и номера телефонов, чтобы мы могли связаться с вами в случае 
										изменения даты.
									</li>
									<li>
										Глубина записи – 6 дней.
									</li>
								</ul>
							</div>
						</div>
					</v-col>
				</v-row>

				<!--  -->

				<v-row :style="`background: ${accent}`">
					<v-col cols="12" class="px-10 py-8 d-flex align-center justify-space-between flex-wrap text-center">
						<div class="text-left white--text fhr-request-label-text">
							<div>Мастер-класс</div>
							<div><b>09:00 «Хоккей для всех»</b></div>
						</div>
						<div v-if="CurrentDate" class="fhr-request-btn-container">
							<v-btn block dark outlined class="rounded-0 mx-auto py-8" style="max-width:350px" @click="OpenWidget(3, 20, '8670671', false)">
								Отправить заявку ( <u>{{ CurrentDateDisplay }}</u> )
							</v-btn>
						</div>
						<v-alert class="mb-0" v-else type="warning">Запись на мастер-класс открывается за 6 дней</v-alert>
					</v-col>
				</v-row>

				<v-row :style="`background: ${primary}`">
					<v-col cols="12" class="py-8 px-10 d-flex align-center justify-space-between flex-wrap text-center">
						<div class="text-left white--text fhr-request-label-text">
							<div>Мастер-класс</div>
							<div><b>10:30 «Воспитанники хоккейных школ»</b></div>
						</div>
						<div v-if="CurrentDate" class="fhr-request-btn-container">
							<v-btn block dark outlined class="rounded-0 mx-auto py-8" @click="ConfirmReservation">
								Отправить заявку ( <u>{{ CurrentDateDisplay }}</u> )
							</v-btn>
						</div>
						<v-alert class="mb-0" v-else type="warning">Запись на мастер-класс открывается за 6 дней</v-alert>
					</v-col>
				</v-row>

				<!--  -->

				<v-dialog v-model="DialogAcknowledge" max-width="640">
					<v-card>
						<v-card-title>Уведомление</v-card-title>
						<v-card-text>Данный мастер-класс предназначен для хоккеистов имеющих навыки катания</v-card-text>
						<v-card-actions>
							<v-spacer />
							<v-btn text color="primary" @click="Acknowledge"> Принимаю </v-btn>
							<v-btn text color="error" @click="DialogAcknowledge = false"> Уйти </v-btn>
							<v-spacer />
						</v-card-actions>
					</v-card>
				</v-dialog>

				<v-dialog v-model="DialogConfirmReservation" max-width="640">
					<v-card>
						<v-card-title>
							<v-spacer />
							<v-btn color="primary" icon @click="DialogConfirmReservation = false">
								<v-icon>mdi-close</v-icon>
							</v-btn>
						</v-card-title>
						<v-divider />
						<v-card-text class="pt-4">
							<span class="text-truncate">Укажите Ваш рост и в каком хоккейном клубе Вы занимаетесь</span>
							<v-form>
								<v-text-field
									v-model="OrderComment"
									outlined
									class="my-3"
									placeholder="Укажите Ваш рост и хоккейный клуб..."
									counter
									maxlength="100"
								/>
								<v-btn @click="OpenWidgetFree()" block large color="primary">Отправить</v-btn>
							</v-form>
						</v-card-text>
					</v-card>
				</v-dialog>

				<v-row>
					<v-col cols="12">
						<SectionGalleryRedMachine />
					</v-col>
				</v-row>

				<v-row>
					<v-col cols="12">
						<the-footer />
					</v-col>
				</v-row>
			</div>
		</v-main>
	</v-app>
</template>

<script lang="ts">
import './style.less';

import Vue from 'vue';
import MenuTop from './components/MenuTop.vue';
import NavDrawer from './components/NavDrawer.vue';
import DialogDisabled from './components/Generic/DialogDisabled.vue';
import SectionGalleryRedMachine from './components/SectionGalleryRedMachine.vue';
import TheFooter from './components/Generic/TheFooter.vue';
import EShopWidget from './codebase/widget.script';

export default Vue.extend({
	components: { MenuTop, NavDrawer, DialogDisabled, TheFooter, SectionGalleryRedMachine },
	name: 'App',

	data: () => ({
		Today: new Date(),
		Image000: require('./assets/images/FHR/2025/Image_1.png'),
		Image001: require('./assets/images/FHR/2025/Image_2.png'),
		Image002: require('./assets/images/FHR/2025/Image_3.png'),
		CurrentDate: null as null | string,
		CurrentDateDisplay: null as null | string,
		Dates: [
			new Date('2025/12/06 10:00'),
			new Date('2025/12/13 10:00'),
			new Date('2025/12/20 10:00'),
			new Date('2026/01/10 10:00'),
			new Date('2026/01/17 10:00'),
			new Date('2026/01/24 10:00'),
			new Date('2026/01/31 10:00'),
			new Date('2026/02/07 10:00'),
			new Date('2026/02/14 10:00'),
			new Date('2026/02/21 10:00'),
		],
		DialogConfirmReservation: false as boolean,
		DialogAcknowledge: false,
		OrderComment: '',
	}),
	created(): void {
		let script = document.createElement('script');
		script.src = 'widget_shop.js';
		script.type = 'text/javascript';
		document.head.append(script);

		this.Dates.every((date: Date) => {
			let d = new Date(date);
			if (this.Today.getTime() < d.getTime()) {
				let minDate = new Date(d.setDate(d.getDate() - 5));
				if (this.Today.getTime() >= minDate.getTime()) {
					this.CurrentDate = date.toISOString().split('T')[0];
					this.CurrentDateDisplay = date.toLocaleDateString().replace('/', '.');
					return false;
				}
			}
			return true;
		});

		let currentDate = this.CurrentDate;

	
	},
	methods: {
		OpenWidget(id: number, tariff: number, seance: string, needComment: boolean) {
			let platform = window as unknown as EShopWidget;
			platform.widgetOpenMaster(id, tariff, seance, this.CurrentDate!, needComment);
		},
		OpenWidgetFree() {
			let platform = window as unknown as EShopWidget;
			platform.widgetShopOpen(4);
		},
		ConfirmReservation() {
			this.DialogAcknowledge = true;
		},
		Acknowledge() {
			this.DialogAcknowledge = false;
			this.OpenWidget(3, 33, '8670672', true);
		},
		style() {
			return `background-color: ${this.primary}`;
		},
	},
	computed: {
		primary() {
			return this.$vuetify.theme.currentTheme.primary;
		},
		accent() {
			return this.$vuetify.theme.currentTheme.accent;
		},
	},
});
</script>

<style scoped lang="less">
.section-info {
	.subheader {
		text-align: center;
		font-size: 24px;
		line-height: normal;
	}

	p {
		font-size: 14px;
		line-height: normal;
	}
}

.section-faq {
	.q {
		font-weight: bold;
		font-size: 18px;
	}

	.a {
		font-size: 14px;
		margin-bottom: 12px;
	}
}

.gum-container {
	max-width: 1400px;
	margin-inline: auto;
	overflow: hidden;

	& > .title {
		font-size: 1.5rem !important;
	}
}

.fhr-request-btn-container {
	width: 100%;
	max-width: 350px;
}

.fhr-request-label-text{
	min-width: 300px;
}
</style>